<template>
	<div class="pui-form">
		<mareaoperacion-modals :modelName="modelName"></mareaoperacion-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<mareaoperacion-form-header
				:modelPk="modelPk"
			></mareaoperacion-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDAREAOPERA -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idareaopera-mareaoperacion`"
									v-model="model.idareaopera"
									:label="$t('mareaoperacion.idareaopera')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
							<!-- CODAREAOPERA -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codareaopera-mareaoperacion`"
									v-model="model.codareaopera"
									:label="$t('mareaoperacion.codareaopera')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="25"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- CODPUE -->
							<v-flex xs12 md2>
								<pui-select
									id="idpuertolocal"
									attach="idpuertolocal"
									:label="$t('mareaoperacion.idpuertolocal')"
									toplabel
									clearable
									required
									:disabled="formDisabled"
									v-model="model"
									modelName="vlupmpuertolocal"
									:itemsToSelect="[{ id: model.idpuertolocal }]"
									:modelFormMapping="{ id: 'idpuertolocal' }"
									itemValue="id"
									itemText="descripcion"
									:order="{ descripcion: 'asc' }"
								></pui-select>
							</v-flex>
							<!-- CODAREAOPERAEDI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codareaoperaedi-mareaoperacion`"
									v-model="model.codareaoperaedi"
									:label="$t('mareaoperacion.codareaoperaedi')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="25"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md4>
								<pui-text-field
									:id="`name-mareaoperacion`"
									v-model="model.name"
									:label="$t('mareaoperacion.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="100"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECINIVIGENCIA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecinivigencia-mareaoperacion`"
									v-model="model.fecinivigencia"
									:label="$t('mareaoperacion.fecinivigencia')"
									:disabled="formDisabled"
									toplabel
									time
									required
								></pui-date-field>
							</v-flex>
							<!-- FECFINVIGENCIA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecfinvigencia-mareaoperacion`"
									v-model="model.fecfinvigencia"
									:label="$t('mareaoperacion.fecfinvigencia')"
									:disabled="formDisabled"
									toplabel
									time
									:min="model.fecinivigencia"
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mareaoperacionActions from './MareaoperacionActions';
import mareaoperacionModals from './MareaoperacionModals.vue';

export default {
	name: 'mareaoperacion-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mareaoperacion-modals': mareaoperacionModals
	},
	data() {
		return {
			modelName: 'mareaoperacion',
			actions: mareaoperacionActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mareaoperacion');
		}
	},
	created() {}
};
</script>
